<app-status-summary [available]="available" [notAvailable]="notAvailable" [outOfOffice]="outOfOffice"></app-status-summary>

<!-- Mobile, Tablet, Desktop -->
<div class="mobile-cards">
  <div class="page">
    @for (statusGroup of agents$ | async; track statusGroup) {
      <app-card-frame [title]="statusGroup[0]?.CurrentEvent.Status.Item.GroupName" class="frame">
        @for (agent of statusGroup; track agent) {
          <app-agent-card [agent]="agent"> </app-agent-card>
        }
      </app-card-frame>
    }
  </div>
</div>

<!-- TV -->
<div class="tv-cards">
  <ion-slides pager="false" [options]="tvSlideOpts" class="wallboard-slides">
    <ion-slide>
      <div class="page">
        @for (statusGroup of agentsPage1$ | async; track statusGroup) {
          <app-card-frame [title]="statusGroup[0]?.CurrentEvent.Status.Item.GroupName" class="frame">
            @for (agent of statusGroup; track agent) {
              <app-agent-card [agent]="agent"> </app-agent-card>
            }
          </app-card-frame>
        }
      </div>
    </ion-slide>
    @if ((agentsPage2$ | async)?.length > 0) {
      <ion-slide>
        <div class="page">
          @for (statusGroup of agentsPage2$ | async; track statusGroup) {
            <app-card-frame [title]="statusGroup[0]?.CurrentEvent.Status.Item.GroupName" class="frame">
              @for (agent of statusGroup; track agent) {
                <app-agent-card [agent]="agent"> </app-agent-card>
              }
            </app-card-frame>
          }
        </div>
      </ion-slide>
    }
    @if ((agentsPage3$ | async)?.length > 0) {
      <ion-slide>
        <div class="page">
          @for (statusGroup of agentsPage3$ | async; track statusGroup) {
            <app-card-frame [title]="statusGroup[0]?.CurrentEvent.Status.Item.GroupName" class="frame">
              @for (agent of statusGroup; track agent) {
                <app-agent-card [agent]="agent"> </app-agent-card>
              }
            </app-card-frame>
          }
        </div>
      </ion-slide>
    }
    @if ((agentsPage4$ | async)?.length > 0) {
      <ion-slide>
        <div class="page">
          @for (statusGroup of agentsPage4$ | async; track statusGroup) {
            <app-card-frame [title]="statusGroup[0]?.CurrentEvent.Status.Item.GroupName" class="frame">
              @for (agent of statusGroup; track agent) {
                <app-agent-card [agent]="agent"> </app-agent-card>
              }
            </app-card-frame>
          }
        </div>
      </ion-slide>
    }
  </ion-slides>
</div>
